import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateDisplayDeleteBookingModal } from "../../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";
import { IoIosCloseCircle } from "react-icons/io";

const DeleteBookingModal = () => {
  const { displayDeleteBookingModal } = useSelector((store) => store.booking);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { handleBookingToBeDeleted } = useAllBookingFunction(setLoading);

  const handleClose = () => {
    dispatch(updateDisplayDeleteBookingModal(false));
  };

  return (
    <Modal
      open={displayDeleteBookingModal}
      centered
      title=""
      width={"auto"}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      onCancel={handleClose}
      footer={
        <div className="w-[100%] flex gap-2 justify-center mt-5 font-outfit">
          <Button
            className="text-[16px] w-[11rem] h-[3rem]
            border-[#007FFF] text-[#007FFF] rounded-[0.5rem] font-[500] "
            onClick={handleClose}
          >
            NO
          </Button>

          <Button
            className="text-[#FFF] text-[16px] rounded-xl  bg-[#FC573B] 
            w-[11rem] h-[3rem] font-[600]"
            onClick={loading ? undefined : handleBookingToBeDeleted}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <div>YES</div>
            )}
          </Button>
        </div>
      }
      closable={false}
    >
      <div className="flex items-center gap-4 font-outfit">
        <div className="w-[38px] h-[38px] rounded-[8px] bg-[#FFE6E2] flex justify-center items-center">
          <IoIosCloseCircle className="text-[#FC573B] text-[22px]" />
        </div>
        <span className=" text-[21px] font-[600] text-[#FC573B]">
          Delete Booking?
        </span>
      </div>
      <div className="text-[#222B45]  text-[18px] font-[500] pt-3">
        Are you sure you want to delete this Booking?
      </div>
    </Modal>
  );
};

export default DeleteBookingModal;
